/** Badge tones from API supplier_status DTO — no local status enums. */

export function supplierStatusTone(bucket) {
  switch ((bucket || '').toLowerCase()) {
    case 'confirmed':
      return 'bg-emerald-100 text-emerald-800 border-emerald-200';
    case 'pending':
      return 'bg-amber-100 text-amber-800 border-amber-200';
    case 'cancelled':
      return 'bg-gray-200 text-gray-700 border-gray-300';
    case 'failed':
      return 'bg-rose-100 text-rose-800 border-rose-200';
    default:
      return 'bg-slate-100 text-slate-700 border-slate-200';
  }
}
